<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Subscription</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Subscription</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'SubscriptionList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body table-responsive p-0">
              <table class="table table-striped">
                <tbody>

                  <tr>
                    <td><b>ID</b></td>
                    <td>{{ value.id }}</td>
                  </tr>

                  <tr>
                    <td><b>User-Id</b></td>
                    <td>{{ value.userId }}</td>
                  </tr>

                  <tr>
                    <td><b>Subscription Plan</b></td>
                    <td>{{ value.subscriptionPlanId }}</td>
                  </tr>

                  <tr>
                    <td><b>Base Subscription-Plan</b></td>
                    <td>{{ value.baseSubscriptionPlanId }}</td>
                  </tr>

                  <tr>
                    <td><b>Subscribe At</b></td>
                    <td>{{ value.subscribeAt }}</td>
                  </tr>

                  <tr>
                    <td><b>Expire At</b></td>
                    <td>{{ value.expireAt }}</td>
                  </tr>

                  <tr>
                    <td><b>Renew At</b></td>
                    <td>{{ value.renewAt }}</td>
                  </tr>

                  <tr>
                    <td><b>Notify At</b></td>
                    <td>{{ value.notifyAt }}</td>
                  </tr>

                  <tr>
                    <td><b>Unsubscribe At</b></td>
                    <td>{{ value.unsubscribeAt }}</td>
                  </tr>

                  <tr>
                    <td><b>Subscription Channel</b></td>
                    <td>{{ value.subChannel }}</td>
                  </tr>

                  <tr>
                    <td><b>Unsubscription Channel</b></td>
                    <td>{{ value.unsubChannel }}</td>
                  </tr>

                  <tr>
                    <td><b>Auto Renew</b></td>
                    <td>{{ value.autoRenew }}</td>
                  </tr>

                  <tr>
                    <td><b>App-Id</b></td>
                    <td>{{ value.appId }}</td>
                  </tr>

                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SubscriptionShow",
  data: () => ({
    value: {

    },
    pre: {

    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.getDetail(this.params.id).then(detail => {
        this.value = detail;
      });

      this.is_loading = false;
    },
    getDetail: function (id) {
      let _this = this;
      return new Promise(resolve => {
        let api_url = "/subscriptions/" + id;
        _this.is_loading = true;
        axios.get(api_url)
          .then(response => {
            _this.value = response.data;
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          })
          .finally(() => {
            _this.is_loading = false;
          });
      });
    },
  },
}
</script>
